export default "__VITE_ASSET__CI1IHckm__"